import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum SortIconVariant {
  SORT1 = '1',
  SORT2 = '2',
  SORT3 = '3',
}

interface ISortIconProps extends IConDefaultType {
  variant?: SortIconVariant;
}

function SortIcon({ color, className, size = 24, rotate = 0, flip, variant = SortIconVariant.SORT1 }: ISortIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SortIconVariant.SORT1 && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.29289 20.7071C5.68342 21.0976 6.31658 21.0976 6.70711 20.7071L10.7071 16.7071C11.0976 16.3166 11.0976 15.6834 10.7071 15.2929C10.3166 14.9024 9.68342 14.9024 9.29289 15.2929L6 18.5858L2.70711 15.2929C2.31658 14.9024 1.68342 14.9024 1.29289 15.2929C0.902369 15.6834 0.902369 16.3166 1.29289 16.7071L5.29289 20.7071Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 3C6.55228 3 7 3.44772 7 4L7 20L5 20L5 4C5 3.44772 5.44772 3 6 3Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 11C14 10.4477 14.4477 10 15 10H22C22.5523 10 23 10.4477 23 11C23 11.5523 22.5523 12 22 12H15C14.4477 12 14 11.5523 14 11Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 15C14 14.4477 14.4477 14 15 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H15C14.4477 16 14 15.5523 14 15Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 19C14 18.4477 14.4477 18 15 18H18C18.5523 18 19 18.4477 19 19C19 19.5523 18.5523 20 18 20H15C14.4477 20 14 19.5523 14 19Z"
            fill={color || '#303037'}
          />
        </svg>
      )}
      {variant === SortIconVariant.SORT2 && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.29289 20.7071C6.68342 21.0976 7.31658 21.0976 7.70711 20.7071L11.7071 16.7071C12.0976 16.3166 12.0976 15.6834 11.7071 15.2929C11.3166 14.9024 10.6834 14.9024 10.2929 15.2929L7 18.5858L3.70711 15.2929C3.31658 14.9024 2.68342 14.9024 2.29289 15.2929C1.90237 15.6834 1.90237 16.3166 2.29289 16.7071L6.29289 20.7071Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 3C7.55228 3 8 3.44772 8 4L8 20L6 20L6 4C6 3.44772 6.44772 3 7 3Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7071 3.29289C17.3166 2.90237 16.6834 2.90237 16.2929 3.29289L12.2929 7.29289C11.9024 7.68342 11.9024 8.31658 12.2929 8.70711C12.6834 9.09763 13.3166 9.09763 13.7071 8.70711L17 5.41421L20.2929 8.70711C20.6834 9.09763 21.3166 9.09763 21.7071 8.70711C22.0976 8.31658 22.0976 7.68342 21.7071 7.29289L17.7071 3.29289Z"
            fill="#ADB0B8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 21C16.4477 21 16 20.5523 16 20L16 4L18 4L18 20C18 20.5523 17.5523 21 17 21Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
      {/* svg에 width/height를 박으면 size prop이 무시된다 — 다른 variant처럼 viewBox만 둔다 */}
      {variant === SortIconVariant.SORT3 && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path
            d="M2.62125 3.15876H4.77276C4.91541 3.15876 5.05222 3.21543 5.15309 3.3163C5.25397 3.41717 5.31063 3.55398 5.31063 3.69664C5.31063 3.83929 5.25397 3.9761 5.15309 4.07697C5.05222 4.17785 4.91541 4.23451 4.77276 4.23451H2.62125C2.4786 4.23451 2.34179 4.17785 2.24091 4.07697C2.14004 3.9761 2.08337 3.83929 2.08337 3.69664C2.08337 3.55398 2.14004 3.41717 2.24091 3.3163C2.34179 3.21543 2.4786 3.15876 2.62125 3.15876ZM13.3788 3.15876H7.46214V2.62088C7.46214 2.47823 7.40547 2.34142 7.3046 2.24055C7.20373 2.13968 7.06692 2.08301 6.92426 2.08301C6.78161 2.08301 6.6448 2.13968 6.54393 2.24055C6.44306 2.34142 6.38639 2.47823 6.38639 2.62088V4.77239C6.38639 4.91505 6.44306 5.05186 6.54393 5.15273C6.6448 5.2536 6.78161 5.31027 6.92426 5.31027C7.06692 5.31027 7.20373 5.2536 7.3046 5.15273C7.40547 5.05186 7.46214 4.91505 7.46214 4.77239V4.23451H13.3788C13.5214 4.23451 13.6583 4.17785 13.7591 4.07697C13.86 3.9761 13.9167 3.83929 13.9167 3.69664C13.9167 3.55398 13.86 3.41717 13.7591 3.3163C13.6583 3.21543 13.5214 3.15876 13.3788 3.15876ZM2.62125 12.8405H6.38639C6.52904 12.8405 6.66585 12.7839 6.76672 12.683C6.8676 12.5821 6.92426 12.4453 6.92426 12.3027C6.92426 12.16 6.8676 12.0232 6.76672 11.9223C6.66585 11.8215 6.52904 11.7648 6.38639 11.7648H2.62125C2.4786 11.7648 2.34179 11.8215 2.24091 11.9223C2.14004 12.0232 2.08337 12.16 2.08337 12.3027C2.08337 12.4453 2.14004 12.5821 2.24091 12.683C2.34179 12.7839 2.4786 12.8405 2.62125 12.8405ZM13.3788 11.7648H9.07577V11.2269C9.07577 11.0843 9.0191 10.9474 8.91823 10.8466C8.81736 10.7457 8.68055 10.689 8.53789 10.689C8.39524 10.689 8.25843 10.7457 8.15756 10.8466C8.05669 10.9474 8.00002 11.0843 8.00002 11.2269V13.3784C8.00002 13.5211 8.05669 13.6579 8.15756 13.7588C8.25843 13.8596 8.39524 13.9163 8.53789 13.9163C8.68055 13.9163 8.81736 13.8596 8.91823 13.7588C9.0191 13.6579 9.07577 13.5211 9.07577 13.3784V12.8405H13.3788C13.5214 12.8405 13.6583 12.7839 13.7591 12.683C13.86 12.5821 13.9167 12.4453 13.9167 12.3027C13.9167 12.16 13.86 12.0232 13.7591 11.9223C13.6583 11.8215 13.5214 11.7648 13.3788 11.7648ZM13.3788 7.46178H11.7652V6.9239C11.7652 6.78124 11.7085 6.64443 11.6076 6.54356C11.5067 6.44269 11.3699 6.38602 11.2273 6.38602C11.0846 6.38602 10.9478 6.44269 10.8469 6.54356C10.7461 6.64443 10.6894 6.78124 10.6894 6.9239V9.07541C10.6894 9.21806 10.7461 9.35487 10.8469 9.45574C10.9478 9.55661 11.0846 9.61328 11.2273 9.61328C11.3699 9.61328 11.5067 9.55661 11.6076 9.45574C11.7085 9.35487 11.7652 9.21806 11.7652 9.07541V8.53753H13.3788C13.5214 8.53753 13.6583 8.48086 13.7591 8.37999C13.86 8.27912 13.9167 8.14231 13.9167 7.99965C13.9167 7.857 13.86 7.72019 13.7591 7.61932C13.6583 7.51844 13.5214 7.46178 13.3788 7.46178ZM2.62125 8.53753H9.07577C9.21843 8.53753 9.35524 8.48086 9.45611 8.37999C9.55698 8.27912 9.61365 8.14231 9.61365 7.99965C9.61365 7.857 9.55698 7.72019 9.45611 7.61932C9.35524 7.51844 9.21843 7.46178 9.07577 7.46178H2.62125C2.4786 7.46178 2.34179 7.51844 2.24091 7.61932C2.14004 7.72019 2.08337 7.857 2.08337 7.99965C2.08337 8.14231 2.14004 8.27912 2.24091 8.37999C2.34179 8.48086 2.4786 8.53753 2.62125 8.53753Z"
            fill={color || '#303037'}
          />
        </svg>
      )}
    </i>
  );
}

export default SortIcon;
